<template>
  <div class="map-mode-wrapper" v-show="show">
    <div ref="mapContainer" class="map-container"></div>
  </div>
</template>

<script>
const L = window.L;
import relatedpointer from "@/utils/relatedpointer";
import { mapTools } from "@/utils/mapTools";
import { tdtAddressToCoord } from "@/api/request/poi.search";
import { getFarmInfo } from "@/api/request/snkd.produce";
import { getStorage } from "@/utils/storage";
import { mapGetters, mapState } from "vuex";
import { shAreaIds, reversePointfn } from "@/mixins/map/shTileLayer";
import { setRoundedImgUrl } from "@/utils";
export default {
  name: "MapMode",
  props: {
    show: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      map: null,
      pageParams: {},
      showShanghaiMap: false, // 是否显示为上海天地图 底图
      hasPathLandNum: false,
      allpolygon: [], //所有地块绘制的多边形 实例
      allMarker: [], //所有地块绘制的marker 作物图标实例
      allMarkerLayer: null,
      allSelectPolygon: [], //地块多边形的选择蒙层 实例
      allSelectMarker: [], //地块选择多边形 marker集
      allMarkerSelectLayer: null,
      markerMap: {
        noselected: require("@/assets/images/farmmap/marker_0.png"),
        selected: require("@/assets/images/farmmap/marker_1.png"),
        disable: require("@/assets/images/farmmap/marker_disable.png"),
      },
      landList: [],
    };
  },
  computed: {
    ...mapGetters("ruralInsure", {
      // landList: "renderMapData",
      showLandList: "showLandList",
    }),
    ...mapState("ruralInsure", {
      isSearch: (state) => state.isSearch,
    }),
  },
  watch: {
    show(val) {
      if (val) {
        this.renderMap();
      }
    },
    showLandList: {
      handler: function () {
        if (!this.show) {
          return;
        }
        if (this.isSearch) {
          this.renderMap();
          this.$store.commit("ruralInsure/removeSearchState");
        } else {
          this.landList = this.getMapData();
        }
      },
      deep: true,
    },
  },
  methods: {
    setRoundedImgUrl,
    // 渲染地图
    renderMap() {
      this.landList = this.getMapData();
      this.$nextTick(() => {
        this.loadMap();
      });
    },
    // 处理获取地图数据
    getMapData() {
      return this.showLandList.map((item) => {
        const obj = item.coLandVO;
        obj.cropList = [item.coCropVO];
        obj.select = item.select;
        obj.disable = item.coLandVO.shGisLandTypeId !== 1 || !item.insureFlag;
        obj.insureFailList = item.insureFailList;
        return obj;
      });
    },
    selectLand(land) {
      const curLand = this.landList.find((e) => e.id == land.id);
      if (curLand.disable) {
        this.$message.closeAll();
        this.$message({
          message: curLand.insureFailList[0],
          type: "warning",
        });
        return;
      }
      this.$store.commit("ruralInsure/changeSelectStatus", land.id);
    },
    async loadMap() {
      // 为了地图按照之前的数据结构渲染，这里处理一下
      const landList = this.landList;
      // 是否显示上海天地图
      // 显示条件：企业被监管+属于上海12个区内
      var farmInfo = JSON.parse(localStorage.getItem("FARMINFO"));
      var companyInfo = JSON.parse(localStorage.getItem("COMPANYINFO"));
      let isInShanghai = shAreaIds.includes(farmInfo.countyId); // 是否是要展示上海天地图的区域
      let companySupervisionFlag = Boolean(companyInfo.supervisionFlag); // 企业是否被监管开关 0：否 1：是
      this.showShanghaiMap = companySupervisionFlag && isInShanghai; // 是否显示为上海天地图 底图
      // 上海监管企业地块 path调整
      // if (!this.map && this.showShanghaiMap) {
      if (this.showShanghaiMap) {
        landList.map((item) => {
          item.path =
            (item.shGisPath &&
              JSON.stringify(reversePointfn(JSON.parse(item.shGisPath)))) ||
            "";
          item.landCenterLat =
            (item.shGisPath && item.shGisLandCenterLat) || "";
          item.landCenterLng =
            (item.shGisPath && item.shGisLandCenterLng) || "";
        });
      }
      if (!this.map) {
        //初始化地图
        const mapInitResult = await mapTools.initMap(
          this.$refs.mapContainer,
          [39.90960456049752, 116.3972282409668],
          this.showShanghaiMap,
          (option) => {
            option.preferCanvas = true;
            return option;
          }
        );
        if (!mapInitResult) return; //从当前页面跳走了
        this.map = mapInitResult;
        L.control
          .zoom({
            position: "bottomright",
            zoomInTitle: "放大",
            zoomOutTitle: "缩小",
          })
          .addTo(this.map); //设置zoom按钮位置
        this.mapEvent(this.map); //地图 事件回调处理
        //渲染地块和marker点
        let nowZoom = this.map.getZoom();
        nowZoom = this.showShanghaiMap ? nowZoom + 10 : nowZoom;
        this.hasPathLandNum = this.hasPathLandfn(landList);
        this.initLandAndMarker(this.map, landList, nowZoom);
        this.initSelectLandAndMarker(this.map, landList, nowZoom);
        this.initLandTooltip(this.map, landList);
        await this.initMapPosition(landList);
        if (!this.hasPathLandNum) {
          this.$message({
            message: "暂无地块轮廓可选择",
            type: "warning",
          });
        }
      } else {
        this.clearMarkersFromLayer(this.allMarkerLayer, this.allMarker); //清空已绘制marker
        this.resizeStatus();
        var nowZoom = this.map.getZoom();
        nowZoom = this.showShanghaiMap ? nowZoom + 10 : nowZoom;
        this.hasPathLandNum = this.hasPathLandfn(landList);
        this.initLandAndMarker(this.map, landList, nowZoom);
        this.initSelectLandAndMarker(this.map, landList, nowZoom);
        this.initLandTooltip(this.map, landList);
        setTimeout(async () => {
          await this.initMapPosition(landList);
        }, 1000);
        if (!this.hasPathLandNum) {
          this.$message({
            message: "暂无地块轮廓可选择",
            type: "warning",
          });
        }
      }
    },
    resizeStatus() {
      this.map.eachLayer((layer) => {
        if (layer.options.type !== "base") {
          this.map.removeLayer(layer);
        }
      });
      this.hasPathLandNum = false;
      this.allpolygon.length =
        this.allMarker.length =
        this.allSelectPolygon.length =
        this.allSelectMarker.length =
          0;
      this.allMarkerLayer = this.allMarkerSelectLayer = null;
    },
    mapEvent(map) {
      const This = this;
      const canvasLayerDoms = document.querySelectorAll(
        ".leaflet-map-pane canvas.leaflet-canvas-icon-layer"
      );
      // 地图点击
      /* map.on("click", function () {
        // console.log(e);
      }); */
      // 地图缩放
      map.on("zoomstart", function () {
        //$('.leaflet-map-pane canvas.leaflet-canvas-icon-layer').css('visibility', 'hidden');
        canvasLayerDoms.forEach((dom) => {
          dom.style.visibility = "hidden";
        });
      });
      map.on("zoomend", function () {
        //$('.leaflet-map-pane canvas.leaflet-canvas-icon-layer').css('visibility', 'visible');
        canvasLayerDoms.forEach((dom) => {
          dom.style.visibility = "visible";
        });
      });
      map.on("zoom", function (e) {
        //根据zoom变化 更新marker显示
        This.refreshMarker(false, e.target._zoom);
      });
    },
    hasPathLandfn(areaList) {
      var haspathland = 0;
      areaList.forEach((landData) => {
        if (
          !landData["path"] ||
          !(JSON.parse(landData["path"]) instanceof Array) ||
          !JSON.parse(landData["path"]).length
        )
          return;
        haspathland++;
      });
      return haspathland;
    },
    initLandAndMarker(map, areaList, zoom, onlyMarker = false) {
      //初始化地块层
      //绘制多边形地块
      if (!onlyMarker) {
        areaList.forEach((landData, index) => {
          if (
            !landData["path"] ||
            !(JSON.parse(landData["path"]) instanceof Array) ||
            !JSON.parse(landData["path"]).length
          )
            return;
          var landPath = JSON.parse(landData["path"]);
          var landPolygon = this.initPolygon(
            index,
            landData.landName,
            landData["id"],
            landPath,
            landData["fillColor"],
            landData["fillColor"],
            0.3
          );
          this.allpolygon.push(landPolygon);
        });
        var polygonsLayer = L.layerGroup(this.allpolygon); //地块轮廓 合并成组 一次性添加
        polygonsLayer.addTo(map);
      }
      //初始化 选择作物图标层
      this.allMarker.length &&
        this.clearMarkersFromLayer(this.allMarkerLayer, this.allMarker); //清空已绘制marker
      if (!this.allMarkerLayer) {
        this.allMarkerLayer = L.canvasIconLayer({}).addTo(map);
        this.allMarkerLayer._canvas.className += " cropMarkerLayer"; //marker 层canvas 加样式
      }
      //绘制选择作物图标
      areaList.forEach((landData) => {
        if (
          !landData["path"] ||
          !(JSON.parse(landData["path"]) instanceof Array) ||
          !JSON.parse(landData["path"]).length
        )
          return;
        var landPath = JSON.parse(landData["path"]);
        // var markerImages = landData["cropList"].map((item) => item["imgUrl"]);
        var markerImages = [];
        if (markerImages.length === 1 && !markerImages[0]) return;
        var markerCenter = [
          landData["landCenterLat"],
          landData["landCenterLng"],
        ];
        if (landData.markerCenter) {
          markerCenter = landData.markerCenter;
        } else {
          //marker 中心点 处理
          if (markerImages.length > 0) {
            var result = relatedpointer.pointerIsInMapfn(
              markerCenter,
              landPath
            );
            if (!result && markerCenter) {
              markerCenter.length = 0;
              markerCenter = landData.markerCenter = relatedpointer.indexfn(
                landPath,
                6
              );
            }
          }
        }
        //是否是小于两亩的地块
        var unit = [0, 666.7, 66.67, 1];
        var landAcre =
          unit[landData["landAcreUnit"]] * parseFloat(landData["landAcre"]);
        var isSmallArea = landAcre < 1333.5 ? true : false; //是否为小于2亩的小地块   //marker显示 特殊处理
        var landIconOptions = this.getLandMarkerOptions(
          zoom,
          markerCenter,
          markerImages,
          isSmallArea,
          1
        );
        //获取单个地块下 所有图标 样式
        var landMarker = landIconOptions.map((option) => {
          try {
            return this.initMarker(
              option.markerImage,
              option.wh,
              option.anchor,
              option.center
            );
          } catch (error) {
            return null;
          }
        });
        this.allMarker.push(...landMarker);
      });
      this.allMarker.length && this.allMarkerLayer.addMarkers(this.allMarker); //marker 合并成组 一次性添加
    },
    getLandMarkerOptions(zoom, center, imagesUrls, isSmallArea, marktype = 0) {
      //marker 数据整合
      if (!imagesUrls.length) return [];
      var iconitem = { iconsrc: [], center: null };
      iconitem.center = center;
      //marker图标 图片圆形处理
      for (var j = 0; j < imagesUrls.length; j++) {
        var imgsrc = this.setRoundedImgUrl(imagesUrls[j], 48);
        iconitem.iconsrc.push(imgsrc);
      }
      //数量太多处理
      var iconlen = iconitem["iconsrc"].length;
      iconlen = iconlen > 4 ? 4 : iconlen;
      var markerOptions = [];
      for (var i = 0; i < iconlen; i++) {
        var aliimg = iconitem["iconsrc"][i];
        var markerPosAnchor = this.computeMarkerPosAnchor(
          zoom,
          iconitem["center"],
          iconlen,
          i,
          isSmallArea,
          marktype
        );
        markerOptions.push({
          wh: markerPosAnchor[0], //marker宽高
          anchor: markerPosAnchor[1], //地块marker 偏移
          markerImage: aliimg, //地块marker 图标
          center: iconitem["center"], //地块marker 坐标
        });
      }
      return markerOptions;
    },
    computeMarkerPosAnchor: function (
      zoom,
      centerlatlng,
      markerlen,
      markerindex,
      isSmallArea,
      markerType = 0
    ) {
      //图标 不同缩放等级 位置和偏移量计算
      //计算marker位置大小 根据中心点，marker数量，序号 综合计算位置以及大小
      var iconposArr = [
        [],
        [[12, 12]],
        [
          [24, 12],
          [0, 12],
        ],
        [
          [12, 24],
          [0, 0],
          [24, 0],
        ],
        [
          [24, 24],
          [0, 24],
          [0, 0],
          [24, 0],
        ],
      ]; //作物marker (1,2,3,4个图标展示位置映射)

      var iconposPlusArr = [
        [],
        [[12, 30]],
        [
          [30, 12],
          [-6, 12],
        ],
        [
          [12, 26],
          [-2, 0],
          [26, 0],
        ],
        [
          [24, 24],
          [0, 24],
          [0, 0],
          [24, 0],
        ],
      ]; //针对上方有select图标情况的 作物图标展示 (1,2,3,4个图标展示位置映射)
      //普通作物 marker 层级与大小映射
      var zoomWithWidthMap = {
        1: 0,
        2: 0,
        3: 0,
        4: 0,
        5: 0,
        6: 0,
        7: 0,
        8: 2,
        9: 4,
        10: 4,
        11: 4,
        12: 6,
        13: 8,
        14: 8,
        15: 8,
        16: 12,
        17: 16,
        18: 24,
        19: 32,
        20: 40,
        21: 48,
        22: 56,
      };
      //作物 小marker 层级与大小映射
      var zoomWithWidthSmallMap = {
        1: 0,
        2: 0,
        3: 0,
        4: 0,
        5: 0,
        6: 0,
        7: 0,
        8: 2,
        9: 4,
        10: 4,
        11: 4,
        12: 6,
        13: 6,
        14: 6,
        15: 6,
        16: 8,
        17: 8,
        18: 12,
        19: 18,
        20: 36,
        21: 42,
        22: 48,
      };
      //select marker 层级与大小映射
      var zoomWithWidthSelectMap = {
        1: 0,
        2: 0,
        3: 0,
        4: 0,
        5: 0,
        6: 0,
        7: 0,
        8: 2,
        9: 4,
        10: 4,
        11: 4,
        12: 4,
        13: 4,
        14: 6,
        15: 6,
        16: 8,
        17: 10,
        18: 16,
        19: 20,
        20: 30,
        21: 42,
        22: 48,
      };
      function getPosArr(posArr) {
        return posArr.map(function (item) {
          item.map((itemplus) => {
            itemplus[0] = parseInt((itemplus[0] * width) / 24);
            itemplus[1] = parseInt((itemplus[1] * width) / 24);
            return itemplus;
          });
          return item;
        });
      }
      let width, iconposArrright;
      switch (markerType) {
        case 1: //显示在select marker下面的作物marker （会整体向上偏移一些）
          width = isSmallArea
            ? zoomWithWidthSmallMap[zoom]
            : zoomWithWidthMap[zoom];
          iconposArrright = getPosArr(iconposPlusArr);
          break;
        case 2: //select marker  （会整体向下偏移一些）
          width = zoomWithWidthSelectMap[zoom];
          iconposArrright = getPosArr(iconposArr);
          break;
        default:
          //普通作物marker
          width = isSmallArea
            ? zoomWithWidthSmallMap[zoom]
            : zoomWithWidthMap[zoom];
          iconposArrright = getPosArr(iconposArr);
          break;
      }
      var anchor = iconposArrright[markerlen][markerindex];
      return [[width, width], anchor];
    },
    initMarker: function (iconUrl, iconSize, iconAnchor, centerlatlng) {
      return L.marker(
        {
          lat: centerlatlng[0],
          lng: centerlatlng[1],
        },
        {
          icon: L.icon({
            iconUrl: iconUrl,
            centerlatlng: centerlatlng, //多个marker中心点
            iconSize: iconSize, //大小
            iconAnchor: iconAnchor, //偏移位置
            bubblingMouseEvents: true,
          }),
        }
      );
    },
    initSelectLandAndMarker(map, areaList, zoom, onlyMarker = false) {
      //初始化选择层
      //绘制多边形对象
      if (!onlyMarker) {
        areaList.forEach((landData, index) => {
          if (
            !landData["path"] ||
            !(JSON.parse(landData["path"]) instanceof Array) ||
            !JSON.parse(landData["path"]).length
          )
            return;
          var landPath = JSON.parse(landData["path"]);
          var fillColor = "rgba(0,0,0,0)",
            opacity = 0.5,
            borderColor = "#000";
          if (landData["disable"]) {
            fillColor = "#fff";
            borderColor = "rgba(0,0,0,0.5)";
            fillColor = "rgba(0,0,0,0.5)";
          } else {
            borderColor = "rgba(0,0,0,0)";
            fillColor = "rgba(0,0,0,0)";
          }
          var landPolygon = this.initPolygon(
            index,
            landData.landName,
            landData["id"],
            landPath,
            borderColor,
            fillColor,
            opacity
          );
          this.allSelectPolygon.push(landPolygon);
        });
        var polygonsSelectLayer = L.layerGroup(this.allSelectPolygon); //地块轮廓 合并成组 一次性添加
        polygonsSelectLayer.addTo(map);
      }
      //初始化 选择作物图标层
      this.allSelectMarker.length &&
        this.clearMarkersFromLayer(
          this.allMarkerSelectLayer,
          this.allSelectMarker
        ); //清空已绘制marker
      if (!this.allMarkerSelectLayer) {
        this.allMarkerSelectLayer = L.canvasIconLayer({}).addTo(map);
        this.allMarkerSelectLayer._canvas.className += " selectMarkerLayer"; //marker 层canvas 加样式
      }
      //绘制选择按钮
      areaList.forEach((landData) => {
        if (
          !landData["path"] ||
          !(JSON.parse(landData["path"]) instanceof Array) ||
          !JSON.parse(landData["path"]).length
        )
          return;
        //获取单个地块下 所有图标 样式
        var landPath = JSON.parse(landData["path"]);
        //绘制地块种植物 marker点
        var markerImages = [this.markerMap.noselected];
        if (landData["select"]) {
          markerImages = [this.markerMap.selected];
        }
        if (landData["disable"]) {
          markerImages = [this.markerMap.disable];
        }
        var markerCenter = [
          landData["landCenterLat"],
          landData["landCenterLng"],
        ];
        if (landData.markerCenter) {
          markerCenter = landData.markerCenter;
        } else {
          var result = relatedpointer.pointerIsInMapfn(markerCenter, landPath);
          if (!result && markerCenter) {
            markerCenter.length = 0;
            markerCenter = landData.markerCenter = relatedpointer.indexfn(
              landPath,
              11
            );
          }
        }
        var landIconOptions = this.getLandMarkerOptions(
          zoom,
          markerCenter,
          markerImages,
          false,
          2
        ); //获取单个地块下 所有图标 样式
        //初始化单个地块下 所有图标
        var landMarker = landIconOptions.map((option) => {
          return this.initMarker(
            option.markerImage,
            option.wh,
            option.anchor,
            option.center
          );
        });
        this.allSelectMarker.push(...landMarker);
      });
      this.allSelectMarker.length &&
        this.allMarkerSelectLayer.addMarkers(this.allSelectMarker); //marker 合并成组 一次性添加
    },
    initPolygon(
      index,
      name,
      areaid,
      path,
      bordercolor,
      fillcolor,
      fillOpacity,
      canvasRender = null
    ) {
      var option = {
        color: bordercolor || "#64C3A4",
        fillColor: fillcolor || "#64C3A4",
        fillOpacity: fillOpacity || 0.5,
        className: "polygonbox",
        weight: 2,
      };
      if (canvasRender) {
        option["renderer"] = canvasRender;
      }
      var polygon = L.polygon(path, option);
      polygon.landName = name;
      polygon.areaColor = fillcolor;
      polygon.areaid = areaid;
      polygon.index = index;
      return polygon;
    },
    clearMarkersFromLayer(markerLayer, allMarker = []) {
      // markerLayer.clearLayers();
      allMarker.forEach(function (marker) {
        markerLayer.removeMarker(marker);
        // markerLayer.removeLayer(marker);
      });
      allMarker.length = 0;
    },
    initLandTooltip(map, areaList) {
      //地块专用透明层 层级最高 实现鼠标经过多边形
      var This = this;
      var tooltipPolygons = [];
      var toolTipRenderer = L.canvas({ padding: 0 });
      areaList.forEach((landData, index) => {
        if (
          !landData["path"] ||
          !(JSON.parse(landData["path"]) instanceof Array) ||
          !JSON.parse(landData["path"]).length
        )
          return;
        var landPath = JSON.parse(landData["path"]);
        var landPolygon = this.initPolygon(
          index,
          landData.landName,
          landData["id"],
          landPath,
          "rgba(255,255,255,0)",
          "rgba(255,255,255,0)",
          0,
          toolTipRenderer
        );
        landPolygon.on("click", function (e) {
          This.landClickHanderfn(true, e.target.index, e.target);
        });
        landPolygon.on("mouseover", function (e) {
          var classstr = landData["disable"] ? "disable" : "";
          landPolygon
            .bindTooltip(e.target.landName, {
              className: classstr,
              sticky: true,
              direction: "top",
              offset: L.point(2, -8),
            })
            .openTooltip();
        });
        tooltipPolygons.push(landPolygon);
      });
      // var layer = L.layerGroup(tooltipPolygons).addTo(map);
      L.layerGroup(tooltipPolygons).addTo(map);
      if (toolTipRenderer._container) {
        toolTipRenderer._container.className += " polygonTooltipLayer"; //marker 层canvas 加样式
      }
    },
    landClickHanderfn(isClickPolygon, index, item) {
      let landinfo = {
        id: item.areaid,
        landName: item.landName,
      };
      //点击多边形或marker 处理
      if (isClickPolygon) {
        // this.landList[index]['select'] = !this.landList[index]['select'];
        this.selectLand(landinfo);
        this.$nextTick(() => {
          this.refreshMarker(true);
        });
      }
    },

    initMapPosition: async function (allLandList = []) {
      var otherGroupLandList = allLandList.filter(
        (item) =>
          item.landName !== "演示地块（可删除）" &&
          item["path"] &&
          JSON.parse(item["path"]) instanceof Array
      );
      var demoLandList = allLandList.filter(
        (item) =>
          item.landName === "演示地块（可删除）" &&
          item["path"] &&
          JSON.parse(item["path"]) instanceof Array
      );
      if (otherGroupLandList.length) {
        //2. 当前组 无地块 其他组有地块 一农场所有地块为中心 (刨除演示地块)
        await this.initLandsPosition(otherGroupLandList);
      } else if (!otherGroupLandList.length && demoLandList.length) {
        //3. 农场无地块轮廓 只有演示地块 演示地块为中心
        await this.initLandsPosition(demoLandList);
      } else {
        //4. 农场无地块轮廓 农场地址坐标为中心
        //没有轮廓地块 定位到农场位置
        const farmInfo = getStorage("FARMINFO");
        const companyId = farmInfo ? farmInfo.companyId : null;
        const farmId = farmInfo ? farmInfo.farmId : null;
        const res = await getFarmInfo({ companyId, farmId });
        let farmDetailVO = null;
        if (res.respCode === 0) {
          farmDetailVO = res.obj.farmDetailVO;
        }
        if (!farmDetailVO) return;
        await this.goFarmPosition(this.map, farmDetailVO, tdtAddressToCoord);
      }
    },
    initLandsPosition(landlist) {
      //初始化单个、多个地块位置显示；新增需求：大于一个地块轮廓时就考虑将演示地块的轮廓不考虑展示在视野内
      return new Promise(async (resolve) => {
        var allpointer = [];
        landlist.forEach((landData) => {
          if (
            !landData["path"] ||
            !(JSON.parse(landData["path"]) instanceof Array)
          )
            return;
          var landPath = JSON.parse(landData["path"]);
          allpointer.push(...landPath);
        });
        if (!allpointer.length) return;
        var bigpolygon = L.polygon(allpointer, {}).getBounds();
        var allzoom = this.map.getBoundsZoom(bigpolygon);
        var allcenter = bigpolygon.getCenter();
        this.map.setView({ lat: allcenter.lat, lng: allcenter.lng }, allzoom);
        resolve();
      });
    },
    async goFarmPosition(map, farmDetailVO, addressGetLocation) {
      var address = "";
      address += farmDetailVO.provinceName ? farmDetailVO.provinceName : "";
      address += farmDetailVO.cityName ? farmDetailVO.cityName : "";
      address += farmDetailVO.countyName ? farmDetailVO.countyName : "";
      address += farmDetailVO.farmAddress ? farmDetailVO.farmAddress : "";
      var result = await addressGetLocation(address);
      if (
        result &&
        result.location &&
        result.location.lat &&
        result.location.lon
      ) {
        map.setView(
          {
            lat: parseFloat(result.location.lat),
            lng: parseFloat(result.location.lon),
          },
          13
        );
      }
    },
    refreshMarker(onlySelectMaker = false, zoom) {
      zoom = zoom || this.map.getZoom();
      zoom = this.showShanghaiMap ? zoom + 10 : zoom;
      !onlySelectMaker &&
        this.initLandAndMarker(
          this.map,
          this.isSearch ? this.searchLandList : this.landList,
          zoom,
          true
        );
      this.initSelectLandAndMarker(
        this.map,
        this.isSearch ? this.searchLandList : this.landList,
        zoom,
        true
      );
    },
  },
};
</script>

<style lang="scss" scoped>
.map-mode-wrapper {
  padding: 0 30px;
  height: 100%;
  .map-container {
    height: calc(100% - 26px);
    border: 1px solid #cccccc;
    z-index: 10;
  }
}
</style>
